import React, { useState } from 'react';
import {
    IconButton,
    Dialog,
    Typography,
    DialogTitle,
    DialogContent,
    Box,
    DialogActions,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { LoadingButton } from '@mui/lab';
import { useTranslation } from 'react-i18next';
import { SpendCreditModalProps } from '../../../interfaces/Credits';
import { useToast } from '../../../hooks/useToast';

const SpendCreditModal: React.FC<SpendCreditModalProps> = ({ open, onClose, onConfirm }) => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { aiChatError } = useToast();

    const handleSpendCredit = async () => {
        try {
            setIsLoading(true);
            onConfirm();
        } catch (error) {
            console.error('Errore durante la spesa del credito:', error);
            aiChatError();
        } finally {
            setIsLoading(false);
        }
    };

    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog
            open={open}
            maxWidth="sm"
            onClose={handleClose}
            PaperProps={{ style: { backgroundColor: '#ffffff' } }}
        >
            <DialogTitle>
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1A1A1A' }}>
                    {t('billing:spend_credit_title')}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ maxWidth: '100%', overflowX: 'hidden' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
                    <Typography variant="body1" sx={{ color: '#475467' }}>
                        {t('billing:spend_credit_description')}
                    </Typography>
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: 3, pt: 2, display: 'flex', gap: 2 }}>
                <LoadingButton
                    onClick={handleClose}
                    sx={{
                        fontSize: { xs: '0.875rem', sm: '1rem' },
                        backgroundColor: '#F8F9FA',
                        color: '#475467',
                        border: '1px solid #DBDBDB',
                        '&:hover': { backgroundColor: '#E9ECEF' },
                        width: '50%'
                    }}
                >
                    {t('common:cancel')}
                </LoadingButton>
                <LoadingButton
                    onClick={handleSpendCredit}
                    loading={isLoading}
                    sx={{
                        fontSize: { xs: '0.875rem', sm: '1rem' },
                        backgroundColor: '#E9495A',
                        color: '#FFFFFF',
                        '&:hover': { backgroundColor: '#E6263B' },
                        '&.Mui-disabled': { backgroundColor: '#E9495A', opacity: 0.5 },
                        width: '50%'
                    }}
                >
                    {t('billing:spend_credit_confirm')}
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
};

export default SpendCreditModal; 